import { useScreenSize } from '@/hooks/screen'
import * as ScreenOrientation from 'expo-screen-orientation'
import { useEffect } from 'react'

export const useLockOrientationOnSmallScreen = (): void => {
    const size = useScreenSize()

    useEffect(() => {
        if (size !== 'small') return

        const handleLock = async () => {
            try {
                const canLock = await ScreenOrientation.supportsOrientationLockAsync(
                    ScreenOrientation.OrientationLock.PORTRAIT_UP
                )

                if (!canLock) return

                await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP)
            } catch {}
        }

        handleLock()
    }, [size])
}
